
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'

console.log('App.tsx is loading...');

function App() {
  console.log('App component rendering...');
  console.log('BASE_PATH:', __BASE_PATH__);
  
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
